import {Component, OnInit} from '@angular/core';
import {CrudConfig} from '@ngx-ivengi/crud';
import {DatagridBaseComponent} from '../datagrid/datagrid.component';
import {DatagridService} from '../datagrid/datagrid.service';
import {Building} from '../building/building.model';
import {Floor} from '../floor/floor.model';
import {Owner} from '../owner/owner.model';
import {Room} from '../room/room.model';
import {Customer} from '../customer/customer.model';
import {EnumerationService} from '../enumeration/enumeration.service';

@Component({
  selector: 'app-archive-client-overview',
  templateUrl: '../datagrid/datagrid.component.html'
})
export class ArchiveClientOverviewComponent extends DatagridBaseComponent implements OnInit {

  public searchEnabled: boolean = true;
  private filterOptions: any;
  public assignmentTypeFilterId: number = this.crudConfig.getFilterId();
  public assignmentStatusFilterId: number = this.crudConfig.getFilterId();

  constructor(
    private datagridService: DatagridService,
    private enumerationService: EnumerationService,
    private crudConfig: CrudConfig
  ) {
    super();
  }

  public ngOnInit(): void {

    this.requestParams
      .addFilterParam({
        id: this.assignmentStatusFilterId,
        key: 'assignment.status',
        operator: 'eq',
        value: 'PROCESSED'
      })
      .addFilterParam({
        id: this.assignmentTypeFilterId,
        key: 'assignment.type',
        operator: 'ne',
        value: 'SURVEY'
      });

    // configure the "search" part, enable specific fields.
    this.datagridSearchComponent.config.filters.owner.enabled           = true;
    this.datagridSearchComponent.config.filters.customer.enabled        = true;
    this.datagridSearchComponent.config.filters.building.enabled        = true;
    this.datagridSearchComponent.config.filters.floor.enabled           = true;
    this.datagridSearchComponent.config.filters.room.enabled            = true;
    this.datagridSearchComponent.config.filters.channelStatus.enabled   = true;
    this.datagridSearchComponent.config.filters.warrantyStatus.enabled  = true;
    this.datagridSearchComponent.config.filters.location.enabled        = true;
    this.datagridSearchComponent.config.filters.throughputType.enabled  = true;
    this.datagridSearchComponent.config.filters.assignment.enabled      = true;
    this.datagridSearchComponent.config.filters.remarks.enabled         = true;
    this.datagridSearchComponent.config.filters.dateFrom.enabled        = true;
    this.datagridSearchComponent.config.filters.dateTill.enabled        = true;
    this.datagridSearchComponent.config.filters.channelNumbers.enabled  = true;

    // add the filter's options
    this.constructFilterOptions();

    // configure the "list" part
    this.datagridListComponent.config.throughputSubgrid.enabled = true;
    this.datagridListComponent.config.exportation.enabled = true;
    this.datagridListComponent.config.loadProfile = true;
    this.datagridListComponent.config.searchOnInit = true;
    this.datagridListComponent.config.enabledColumns = [
      'building.name',
      'floor.name',
      'channel.label',
      'assignment.date',
      'channel.throughputCount',
      'channel.dimension',
      'channel.location',
      'channel.finish',
      'channel.remarks',
      'roomFrom.name',
      'roomTo.name'
    ];

    // bind onSelect methods
    this.datagridSearchComponent.config.filters.building.onSelect = this.onBuildingSelect.bind(this);
    this.datagridSearchComponent.config.filters.floor.onSelect    = this.onFloorSelect.bind(this);

    // trigger the super's ngOnInit which finishes configuration of the dataGrid component
    super.ngOnInit();
  }

  private constructFilterOptions() {
    this.datagridService.getFilterOptionsForClient().subscribe((response: any) => {
      this.filterOptions = response;

      if(response.owners) {
        this.datagridSearchComponent.config.filters.owner.options = response.owners.map((ownerData: any) => {
          const owner = new Owner();
          owner.fromResponse(ownerData);
          return owner;
        });
      }

      if(response.customers) {
        this.datagridSearchComponent.config.filters.customer.options = response.customers.map((customerData: any) => {
          const customer = new Customer();
          customer.fromResponse(customerData);
          return customer;
        });
      }

      if(response.buildings) {
        this.datagridSearchComponent.config.filters.building.options = response.buildings.map((buildingData: any) => {
          const building = new Building();
          building.fromResponse(buildingData);
          return building;
        });
      }
    });

    this.enumerationService.get('warranty-status').subscribe((warrantyStatuses: string[]) => {
      this.datagridSearchComponent.config.filters.warrantyStatus.options = warrantyStatuses;
    });

    this.enumerationService.get('channel-location').subscribe((locations: string[]) => {
      this.datagridSearchComponent.config.filters.location.options = locations;
    });
  }

  public onBuildingSelect() {
    this.datagridSearchComponent.config.filters.floor.value = '';
    this.datagridSearchComponent.config.filters.floor.options = [];
    this.datagridSearchComponent.config.filters.room.value = '';
    this.datagridSearchComponent.config.filters.room.options = [];

    if(this.datagridSearchComponent.config.filters.building.value) {
      this.filterOptions.buildings.forEach((building) => {
        if(building.id === this.datagridSearchComponent.config.filters.building.value) {
          this.datagridSearchComponent.config.filters.floor.options = building.floors.map((floorResponse: any) => {
            const floor = new Floor();
            floor.fromResponse(floorResponse);
            return floor;
          });
        }
      });
    }
  }

  public onFloorSelect() {
    this.datagridSearchComponent.config.filters.room.value = '';
    this.datagridSearchComponent.config.filters.room.options = [];

    if(this.datagridSearchComponent.config.filters.floor.value) {
      this.filterOptions.buildings.forEach((building) => {
        if(building.id === this.datagridSearchComponent.config.filters.building.value) {
          building.floors.forEach((floor: any) => {
            if(floor.id === this.datagridSearchComponent.config.filters.floor.value) {
              this.datagridSearchComponent.config.filters.room.options = floor.rooms.map((roomResponse: any) => {
                const room = new Room();
                room.fromResponse(roomResponse);
                return room;
              });
            }
          });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/archive/archive-client-overview.component.ts